module.exports = __webpack_public_path__ + "static/media/money-out.36cc9acf.svg";